import Promise from 'promise-polyfill';
import Experiments from '@wix/wix-experiments';

if (typeof window === 'object') {
  window.Promise = window.Promise || Promise;
}
import 'whatwg-fetch';
import { warnAndReturn } from './utils';
import { defaultProfileImage } from './config';
import { domains } from './data/constants.js';
import { Specs } from './experiments';

export const i18n = config =>
  fetch(`${config.baseUrl}assets/locale/messages/messages_${config.language}.json`)
    .then(response => response.json())
    .catch(warnAndReturn('Error getting i18n files', null));

export const userDetails = () =>
  fetch(window.__DEBUG__ ? `/userDetails` : `//${domains.wixManaged}/_api/wix-html-login-webapp/user/getUserDetails`, {
    headers: new Headers({ Accept: 'application/json' }),
    cache: 'no-store',
    credentials: 'include',
  })
    .then(response => response.json())
    .then(response => (response.success && response.errorCode === 0 ? response.payload : null))
    .catch(warnAndReturn('Error getting user details', null));

export const profileImage = config =>
  fetch(window.__DEBUG__ ? `/userImage` : `//${domains.wixManaged}/_api/account-info-server/profileimage`, {
    headers: new Headers({ Accept: 'application/json' }),
    credentials: 'include',
  })
    .then(response => response.json())
    .then(response => response.profileImage || defaultProfileImage(config))
    .catch(warnAndReturn('Error getting profile image, set to default', defaultProfileImage(config)));

const NEW_FOOTER_LANGUAGES_TO_TEST = [];

export const experiments = async (config, experimentManagerOptions = {}) => {
  const experimentsManager = createExperimentManager(experimentManagerOptions);

  if (NEW_FOOTER_LANGUAGES_TO_TEST.includes(config.language)) {
    experimentsManager.conduct(Specs.EnableNewWixFooter, 'false');
  }

  if (config.language === 'pt') {
    experimentsManager.conduct(Specs.EnableCompanyInfoForWixFooterInBrazil, 'false');
  }

  experimentsManager.conduct(Specs.EnableLegalLinkUS, 'false');

  return experimentsManager.ready().then(() => experimentsManager.all());
};

function createExperimentManager(optionsOverrides = {}) {
  const { origin } = window.location;
  const defaultOptions =
    origin === 'https://status.wix.com' ? { baseUrl: 'https://manage.wix.com' } : { useNewApi: window.WIX_HF_DEBUG };

  return new Experiments({ ...defaultOptions, ...optionsOverrides });
}
